import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";
import { FreeToPlayAnimatedIconDefaultBox } from "./free-to-play-animated-icon.default.box";

const MutualBox = styled(FreeToPlayAnimatedIconDefaultBox)`
    right: 20px;
    bottom: ${props => props.isHybridEmbedded? `calc(env(safe-area-inset-bottom) + 86px)` : '20px'};
`;

const PCBox = styled(MutualBox)`
    width: 100px;
`;

const MobileBox = styled(MutualBox)`
    width: 70px;
`;


export const FreeToPlayAnimatedIcon2Box = styledByDevice(PCBox,MobileBox);